import * as types from "../actions/types";

const INITIAL_STATE = {
  products_sold: null,
  inventory_counts: null,
  product_inventory: null
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.FETCH_PRODUCTS_SOLD_SUCCESS:
      return { ...state, products_sold: action.payload };
    case types.FETCH_ACTUAL_INVENTORY_COUNTS:
      return { ...state, inventory_counts: action.payload };
    case types.FETCH_PRODUCT_INVENTORY:
      return { ...state, product_inventory: action.payload };
    default:
      return state;
  }
}
